import { Directive, ElementRef, inject, Input, Renderer2 } from '@angular/core';

@Directive({ selector: 'a[email]' })
export class EmailDirective {
  private _elementRef = inject(ElementRef);
  private _renderer = inject(Renderer2);

  @Input()
  public set email(email: string) {
    if (email) {
      this._renderer.setAttribute(
        this._elementRef.nativeElement,
        'href',
        'mailto:' + email.trim(),
      );
    } else {
      this._renderer.removeAttribute(this._elementRef.nativeElement, 'href');
    }
  }
}
